export const accountsRoutes = {
    root: 'accounts',
};

export const accountsLinks = routesToLinks(accountsRoutes);

export const groupsRoutes = {
    root: 'groups',
};

export const organizationRoutes = {
    root: 'organizations',
};

export const documentsRoutes = {
    root: 'documents',
};

export const reportsRoutes = {
    root: 'reporting',
};

export const announcementsRoutes = {
    root: '',
    form: 'announcement',
};

export const announcementsLinks = routesToLinks(announcementsRoutes);

export const settingsRoutes = {
    root: 'settings',
};
export const settingsLinks = routesToLinks(settingsRoutes);

export const configurableListsRoutes = {
    root: 'configurable-lists',
};

export const configurableListsLinks = routesToLinks(configurableListsRoutes);

export const editablePagesRoutes = {
    root: 'editable-pages',
};
export const editablePagesLinks = routesToLinks(editablePagesRoutes);

export const configurationsRoutes = {
    root: 'configurations',
};

export const configurationsLinks = routesToLinks(configurationsRoutes);

export const supportPagesRoutes = {
    root: 'support',
};

export const supportPagesLinks = routesToLinks(supportPagesRoutes);

export const contactUsRoutes = {
    root: 'contact-us',
};

export const contactUsLinks = routesToLinks(contactUsRoutes);

function routesToLinks<T extends { root: string; [key: string]: unknown }>(routes: T, parentRoute = ''): T {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const links = {} as any;
    const baseRoute = parentRoute + '/' + routes.root;
    for (const [key, value] of Object.entries(routes)) {
        if (typeof value === 'string') {
            if (key === 'root') {
                links[key] = baseRoute;
            } else {
                links[key] = baseRoute + '/' + value;
            }
        } else if (value != null && typeof value === 'object') {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            links[key] = routesToLinks(value as any, baseRoute);
        }
    }
    return links;
}
